import React from 'react'
import xss from 'xss'

import { Link, LinkProps } from '../Link/Link'

export type BreadcrumbProps = {
  links: LinkProps[]
  isReversed?: boolean
  testId?: string
}

/**
 * Presentational breadcrumb trail. Renders all crumbs as links except the
 * last, which denotes the current page as plain text.
 */
export const Breadcrumb = (props: BreadcrumbProps) => {
  const { links, isReversed = false, testId } = props

  return (
    <nav className="u-flex u-flexAlignItemsStretch">
      <ul
        className={`Breadcrumb u-flexJustifyStart u-borderBottom0${
          isReversed ? ' Breadcrumb--reversed' : ''
        }`}
      >
        {links.map((link: LinkProps, index: number) => {
          const isLast = index === links.length - 1
          const key = link.url || link.name || index
          const crumbTestId = testId
            ? `${testId}-breadcrumb-${index}`
            : undefined

          return isLast ? (
            <li
              className="Breadcrumb-item u-textSizeMsrm1"
              key={key}
              data-testid={crumbTestId}
              dangerouslySetInnerHTML={{ __html: xss(link.name) }}
            />
          ) : (
            <li className="Breadcrumb-item" key={key}>
              <Link
                url={link.url}
                onClick={link.onClick}
                className="u-textNoWrap u-textSizeMsrm1"
                name={link.name}
                analyticsName={link.analyticsName}
                testId={crumbTestId}
              />
            </li>
          )
        })}
      </ul>
    </nav>
  )
}
